import { CURRENCY_SYMBOL } from 'utils/constants';
import * as Yup from 'yup';

type Errors = {
  refundAmount?: string;
  orderAmount?: string;
  splitAmount?: string;
};

export const validate = orderAmount => values => {
  const errors: Errors = {};

  if (values.refundAmount === '')
    errors.refundAmount = 'This field cannot be left blank';
  else if (values.refundAmount < 0)
    errors.refundAmount = 'Enter a valid amount';
  else if (values.refundAmount < 1)
    errors.refundAmount = `Less than ${
      CURRENCY_SYMBOL.INR
    }1 refunds are not allowed`;
  else if (
    values.refundAmount &&
    Number(orderAmount) < Number(values.refundAmount)
  ) {
    errors.refundAmount =
      'Refund amount cannot exceed the maximum allowed amount';
  }

  const splitVendorAmount = values.splitVendorArray.length
    ? values.splitVendorArray.reduce((val1, val2) => Number(val1) + Number(val2.amount), 0) // eslint-disable-line
    : 0;
  if (
    splitVendorAmount > Number(values.refundAmount) &&
    !errors.refundAmount &&
    values.splitRefund
  ) {
    errors.splitAmount = 'Split amount cannot exceed refund amount';
  }
  return errors;
};

const validationSchema = isSplit => {
  const splitRefundSchema = {
    is: splitRefund => splitRefund,
    then: Yup.array().of(
      Yup.object({
        amount: Yup.number()
          .required('This field cannot be left blank')
          .typeError('Enter a valid amount'),
        name: Yup.string(),
      }),
    ),
    otherwise: Yup.array(),
  };

  return Yup.object({
    refundAmount: Yup.number()
      .positive('Enter a valid amount')
      .required('This field cannot be left blank')
      .typeError('Enter a valid amount'),
    note: Yup.string(),
    splitRefund: Yup.boolean(),
    splitVendorArray: isSplit
      ? Yup.array().when('splitRefund', splitRefundSchema)
      : Yup.array(),
  });
};

export default validationSchema;
